import React from "react";
import "./styles/index.scss";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import ActivateIcon from "../../common/icons/activateIcon";
import { clickToLinkHandler } from "../../../helpers/utils";

const ActivateForm = () => {
  return (
    <React.Fragment>
      <div className="activate-form-container">
        <div className="title-container">
          <ActivateIcon />
          <div className="title">Activate Account</div>
        </div>
        <Delimiter type="headline" shift="18" />
        <div className="description">
          <p>Registration is completed.</p>
          <p>Check your email and click on activate button from email.</p>
        </div>
        <Delimiter type="internal" shift="18" />
        <div className="links-container center-block">
          <div
            className="link"
            onClick={() => {
              clickToLinkHandler("/");
            }}
          >
            Refresh page
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ActivateForm;
